<samplicity-navbar [permissions]="permissions" [selectedClientId]="selectedClientId" #samplicityNavbar>
  <ng-container navbar-content>
    <samplicity-client-select></samplicity-client-select>
    <samplicity-user-dropdown></samplicity-user-dropdown>
  </ng-container>
</samplicity-navbar>
<samplicity-spinner-overlay *ngIf="isLoading" messageTextTranslated="Loading..."></samplicity-spinner-overlay>
<router-outlet></router-outlet>

